import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface ClickEventArgs {
  preventDefault?: Function;
  stopPropagation?: Function;
  value?: any;
}

class ClickEvent extends EventData<Clickable> implements ClickEventArgs {

  preventDefault?: Function;
  stopPropagation?: Function;
  value?: any;

  constructor({ preventDefault, stopPropagation, value }: ClickEventArgs = {}) {
    super();

    this.preventDefault = preventDefault;
    this.stopPropagation = stopPropagation;
    this.value = value;
  }
}

class ClickEventListener extends EventListener<Clickable, ClickEvent, ClickEventArgs> {

  constructor() {
    super(ClickEvent);
  }

}

export default interface Clickable extends Mountable {

  /** @event */
  onClick: ClickEventListener;

  /** @event */
  onDoubleClick: ClickEventListener;

  /** @event */
  onContextMenuClick: ClickEventListener;

}

export { ClickEventListener, ClickEvent };
